import { ReactComponent as EventButtonBg } from '../../../assets/svgs/event-btn-bg-star.svg';
import { ReactComponent as IconEvent } from '../../../assets/svgs/icon-event.svg';
import { ReactComponent as IconReservation } from '../../../assets/svgs/icon-reservation.svg';
import strings from '../../../constants/strings.constants';
import { Partner } from '../../../apis/models/partner/res/Partner';
import Button from '../../../components/atom/Button';
import NbomLandingPage from './components/NbomLandingPage';
import { keyframes } from '@emotion/react';
import { NavigateFunction } from 'react-router';
import Color from 'color';

export const revealTransition = keyframes`
  
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    
    to {
      opacity: 1;
      transform: translateY(0);
    }
    
  `;

export const renderCustomLandingPage = (
  partnerCode = '',
  buttonActions: {
    onEventMenuClick: () => void;
    onBookAppointmentClick: () => void;
    onReservationHistoriesClick: () => void;
  },
  partner?: Partner,
) => {
  switch (partnerCode) {
    case 'nbom-hd':
      return (
        <NbomLandingPage buttonActions={buttonActions} partner={partner} />
      );
    default:
      return null;
  }
};

export const renderButtons = (
  buttonActions: {
    onEventMenuClick: () => void;
    onBookAppointmentClick: () => void;
    onReservationHistoriesClick: () => void;
  },
  partner?: Partner,
  navigate?: NavigateFunction,
) => {
  const eventMenuVisible =
    partner?.productViewConfig?.mimoWebViewConfig?.useThisMonthEventButton ??
    true;
  const semanticColor =
    partner?.productViewConfig?.mimoWebViewConfig?.semanticColor;

  const eventButtonBaseColor =
    semanticColor?.eventRouteButtonGradirentBaseColor || '#3B82F6';
  const treatmentButtonType = semanticColor?.treatmentButtonType || 'dark';

  return (
    <>
      {eventMenuVisible && (
        <Button
          style={{
            background: `linear-gradient(to right, ${eventButtonBaseColor}, ${Color(eventButtonBaseColor).darken(0.15).hex()})`,
          }}
          onClick={() => {
            buttonActions.onEventMenuClick();
          }}
        >
          <IconEvent />
          {strings.thisMonthEvent}
          <div className="absolute right-8">
            <EventButtonBg />
          </div>
        </Button>
      )}

      <Button
        type={treatmentButtonType}
        style={{ fontWeight: 300 }}
        onClick={() => {
          buttonActions.onBookAppointmentClick();
        }}
      >
        <IconReservation />
        {strings.bookAppointment}
      </Button>

      <Button
        type="lightGray"
        style={{ fontWeight: 400 }}
        onClick={() => {
          buttonActions.onReservationHistoriesClick();
        }}
      >
        {strings.reservationHistoriesButton}
      </Button>
    </>
  );
};
